import * as React from 'react';
import * as styles from './PeopleCard.css';
import { IAIcon } from '../../icon/Icon';
import { ConditionalOutputFactory } from '../../../services/ConditionalOutputFactory';
import { ConditionalOutput } from '../../../services/ConditionalOutput';
import { LocalizationService } from '../../../services/LocalizationService';
import { Helper } from '../../../Helper';

export interface IPeopleCardProps {
  properties: IPeopleCardProperties[];
  image?: string;
  backgroundColor: string;
  linkedTextColor?: string;
  index?: number;
  nameLink?: string;
  tenant?: string;
  isMobile?: boolean;
}

export interface IPeopleCardProperties {
  property?: string;
  value?: string;
  iconTitle?: string;
  iconColor?: string;
  iconSize?: number;
  classNames?: string[];
  link?: string;
  templateLink?: any;
}

export interface IPeopleCardState {
}

export class PeopleCard extends React.Component<IPeopleCardProps, IPeopleCardState> {


  private localizationService: LocalizationService = new LocalizationService();

  constructor(props) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getProfilePictureColor(): { backgroundColor: string, color: string } {
    switch (Math.floor(Math.random() * 19)) {
      case 0:
        return {
          backgroundColor: "#ddbec3",
          color: "#750b1c"
        }
      case 1:
        return {
          backgroundColor: "#d0b1b2",
          color: "#a4262c"
        }
      case 2:
        return {
          backgroundColor: "#dfb8b9",
          color: "#d13438"
        }
      case 3:
        return {
          backgroundColor: "#e1d3b0",
          color: "#986f0b"
        }
      case 4:
        return {
          backgroundColor: "#c9ddb2",
          color: "#498205"
        }
      case 5:
        return {
          backgroundColor: "#a7d6a7",
          color: "#0b6a0b"
        }
      case 6:
        return {
          backgroundColor: "#add9db",
          color: "#038387"
        }
      case 7:
        return {
          backgroundColor: "#aed9e3",
          color: "#005b70"
        }
      case 8:
        return {
          backgroundColor: "#b5d0e5",
          color: "#0078d4"
        }
      case 9:
        return {
          backgroundColor: "#b7cddf",
          color: "#004e8c"
        }
      case 10:
        return {
          backgroundColor: "#c5ccef",
          color: "#4f6bed"
        }
      case 11:
        return {
          backgroundColor: "#ccbcdf",
          color: "#5c2e91"
        }
      case 12:
        return {
          backgroundColor: "#d8cbeb",
          color: "#8764b8"
        }
      case 13:
        return {
          backgroundColor: "#e1b9e7",
          color: "#881798"
        }
      case 14:
        return {
          backgroundColor: "#e9bfe4",
          color: "#c239b3"
        }
      case 15:
        return {
          backgroundColor: "#e5b6d3",
          color: "#e3008c"
        }
      case 16:
        return {
          backgroundColor: "#e7d1c1",
          color: "#8e562e"
        }
      case 17:
        return {
          backgroundColor: "#d4cfce",
          color: "#7a7574"
        }
      case 18:
        return {
          backgroundColor: "#d0dadd",
          color: "#69797e"
        }
      default:
        return {
          backgroundColor: "#dbbbc0",
          color: "#750b1c"
        }
    }
  }

  public render() {
    let firstNameChar: string;
    let lastNameChar: string;
    let nameProperty: IPeopleCardProperties;
    let jobTitleProperty: IPeopleCardProperties;
    let departmentProperty: IPeopleCardProperties;
    let locationProperty: IPeopleCardProperties;
    let workEmailProperty: IPeopleCardProperties;
    let phoneProperty: IPeopleCardProperties;
    // let teamsProperty: IPeopleCardProperties;
    let telephonesProperty: IPeopleCardProperties;
    let userInfo = [];
    let buttons = [];

    if (this.props.properties) {
      this.props.properties.forEach((property: IPeopleCardProperties) => {
        switch (property.property) {
          case 'PreferredName':
            nameProperty = property;
            break;
          case 'JobTitle':
            jobTitleProperty = property;
            break;
          case 'Department':
            departmentProperty = property;
            break;
          case 'OfficeNumber':
            locationProperty = property;
            break;
          case 'WorkEmail':
            if (/[@\.]/.test(property.value)) {
              workEmailProperty = property;
              let tenantString = this.props.tenant;
              if (tenantString.toLowerCase().indexOf(".sharepoint.com")) {
                tenantString = tenantString.toLowerCase().replace(".sharepoint.com", "");
              }
            }
            // else {
            //   if (workEmailProperty) {
            //     teamsProperty = property;
            //   }
            // }
            break;
          case 'MobilePhone':
            phoneProperty = property;
            break;
          case 'WorkPhone':
            phoneProperty = property;
            break;
          case 'WorkPhone, MobilePhone':
            telephonesProperty = property;
            break;
          default:
            break;
        }

      });
      firstNameChar = nameProperty?.value?.split(' ')[0][0];
      const lastName: string = nameProperty?.value?.split(' ')[nameProperty.value?.split(' ').length - 1];
      lastNameChar = nameProperty?.value?.split(' ')[0] !== lastName ? lastName[0] : firstNameChar;
      userInfo.push(
        <div
          key={`card:${this.props.index}${nameProperty?.property}`}
          className={styles.IA_name}
          onClick={() => {
            if (workEmailProperty?.value) {
              Helper.openProfilePageWithImageUrl(workEmailProperty.value, this.props.image);
            }
          }}
        >
          <p>
            {nameProperty?.value}
          </p>
        </div>
      );
      if (jobTitleProperty) {
        userInfo.push(
          <div
            key={`card:${this.props.index}${jobTitleProperty.property}`}
            className={styles.IA_jobTitle}
          >
            <a href={jobTitleProperty.templateLink} target="_blank">
              {jobTitleProperty.value}
            </a>
          </div>
        );
      }
      if (departmentProperty) {
        userInfo.push(
          <div
            key={`card:${this.props.index}${departmentProperty.property}`}
            className={styles.IA_department}
          >
            <a href={departmentProperty.templateLink} target="_blank">
              {departmentProperty.value}
            </a>
          </div>
        );
      }
      if (locationProperty) {
        userInfo.push(
          <div
            key={`card:${this.props.index}${locationProperty.property}`}
            className={styles.IA_department}
          >
            <a href={locationProperty.templateLink} target="_blank">
              {locationProperty.value}
            </a>
          </div>
        );
      }
      if (workEmailProperty) {
        buttons.push(
          <div
            key={`card:${this.props.index}${workEmailProperty.property}`}
            className={styles.IA_email}
            style={{
              backgroundColor: `${this.props.linkedTextColor}21`
            }}
          >
            <a href={`mailto:${workEmailProperty.value}`} target="_blank">
              <IAIcon
                title={workEmailProperty.iconTitle}
                size={24}
                color={this.props.linkedTextColor}
              />
            </a>
          </div>
        );
      }
      if (phoneProperty) {
        buttons.push(
          <div
            key={`card:${this.props.index}${phoneProperty.property}`}
            className={styles.IA_phone}
            style={{
              backgroundColor: `${this.props.linkedTextColor}21`
            }}
          >
            <a href={`tel:${phoneProperty.value}`} target="_blank">
              <IAIcon
                title={phoneProperty.iconTitle}
                size={24}
                color={this.props.linkedTextColor}
              />
            </a>
          </div>
        );
      }
      if (telephonesProperty) {
        let numbers = telephonesProperty.value.split('/');
        numbers.forEach((number, i) => {
          buttons.push(
            <div
              key={`card:${this.props.index}${telephonesProperty.property}${number}`}
              className={styles.IA_phone}
              style={{
                backgroundColor: `${this.props.linkedTextColor}21`
              }}
            >
              <a href={`tel:${number.trim()}`} target="_blank">
                <IAIcon
                  title={i !== 1 ? telephonesProperty.iconTitle : 'Cell Phone 2'}
                  size={24}
                  color={this.props.linkedTextColor}
                />
              </a>
            </div>
          );
        })
      }
      if (workEmailProperty) {
        buttons.push(
          <div
            key={`card:${this.props.index}Teams`}
            className={styles.IA_teams}
            style={{
              backgroundColor: `${this.props.linkedTextColor}21`
            }}
          >
            <a href={this.props.isMobile ? `https://teams.microsoft.com/l/chat/0/0?users=${workEmailProperty.value}` : `sip:https://teams.microsoft.com/l/chat/0/0?users=${workEmailProperty.value}`} target="_blank">
              <IAIcon
                title={"Teams"}
                size={24}
                color={this.props.linkedTextColor}
              />
            </a>
          </div>
        );
      }
      this.props.properties.forEach((property: IPeopleCardProperties, index: number) => {
        if (property.property !== 'Path' && property.property !== 'PreferredName' && property.property !== 'WorkEmail' && property.property !== "JobTitle" && property.property !== "OfficeNumber" && property.property !== "Department") {
          userInfo.push(
            <div key={index}>
              <div className={styles.IA_jobTitle}>
                {ConditionalOutputFactory
                  .WithDefault(<div>{property.value}</div>)
                  .OnCondition(
                    property.property === 'WorkEmail' ||
                    property.property === 'MobilePhone' ||
                    property.property === 'WorkPhone',
                    <a href={`${property.link}${property.value}`} className={styles.IA_credential_onHover} style={{ textDecoration: "none" }} target="_blank">
                      {property.value}
                    </a>)
                  .OnCondition(/[,]/.test(property.property) && property.link === 'tel:' && property.templateLink === null,
                    property.value.split('/').map((number, arrayIndex) => {
                      return (
                        <div key={arrayIndex}>
                          <a href={`${property.link}${number}`} className={styles.IA_credential_onHover} style={{ textDecoration: "none", float: 'left' }} target="_blank">
                            {number}
                          </a> {new ConditionalOutput(<div style={{ float: "left", marginLeft: 3, marginRight: 3 }}>/</div>)
                            .OnCondition(property.value.split('/').length - 1 === arrayIndex,
                              <div></div>)
                            .Last()}
                        </div>
                      )
                    }))
                  .OnCondition(property.templateLink !== null,
                    <a href={property.templateLink} style={{ textDecoration: "none" }} target="_blank">
                      {property.value}
                    </a>)
                  .Last()}
              </div>
            </div>
          );
        }
      });
    }
    const profilePictureColor = this.getProfilePictureColor();
    return (
      <div className={styles.IA_peopleCard}>
        <p>
          <div
            className={styles.IA_personaSmallProfileImageWrapper}
            style={{
              backgroundColor: profilePictureColor.backgroundColor,
              color: profilePictureColor.color
            }}
            onClick={() => {
              if (workEmailProperty?.value) {
                Helper.openProfilePageWithImageUrl(workEmailProperty.value, this.props.image);
              }
            }}
          >
            <div className={styles.IA_personaSmallProfileImageText}>
              {firstNameChar + lastNameChar}
            </div>
            <div
              className={styles.IA_personaSmallProfileImage}
              style={{
                backgroundImage: `url('${this.props.image ? this.props.image : ""}')`
              }} />
          </div>
        </p>
        <div className={styles.IA_peopleCard_content} >
          {userInfo}
        </div>
        <div
          id={`IA_Buttons_${this.props.index}`}
          style={{
            clear: "both",
            display: "flex",
            justifyContent: "center",
            gap: 20,
            marginTop: 10
          }}>
          {buttons}
        </div>
      </div>
    );
  }
}            